export default [
  '/about/contact-us/',
  '/about/email/',
  '/about/history/',
  '/about/careers/benefits/',
  '/about/careers/locations/',
  '/about/careers/roles/',
  '/about/careers/working-at-aaa/',
  '/about/communities/',
  '/about/traffic-safety-newsletter/',
  '/about/traffic-safety-newsletter/thanks/',
  '/automotive/autobuying/team/',
  '/automotive/autobuying/thank-you/',
  '/automotive/autobuying/extended-warranty/',
  '/automotive/autobuying/gap-auto-insurance/',
  '/automotive/autobuying/quote/',
  '/automotive/autobuying/service-plans-quote/',
  '/automotive/battery/',
  '/automotive/battery/battery-tender/',
  '/automotive/battery/faq/',
  '/automotive/carcare/about/',
  '/automotive/carcare/service-plans/',
  '/automotive/carcare/services/',
  '/automotive/carcare/services/oil-change/',
  '/automotive/roadside/lockout/',
  '/automotive/roadside/towing/',
  '/insurance/aetna-medicare-supplement-agents/',
  '/insurance/medicare-supplement-plans/',
  '/insurance/products/business/',
  '/insurance/products/business/quote/',
  '/insurance/products/auto/',
  '/insurance/products/boat/',
  '/insurance/products/flood/',
  '/insurance/products/health/',
  '/insurance/products/home/',
  '/insurance/why-aaa/',
  '/landing/buy-insurance/',
  '/membership/welcome/',
  '/membership/join/',
  '/membership-required/',
  '/privacy-policy/',
  '/tmic/auto/',
  '/tmic/homeowner/',
  '/tmic/manage-policy/',
  '/tmic/motorcycle/',
  '/tmic/products/',
  '/tmic/why-tmic/',
  '/travel/disney/',
  '/travel/disney/dining/',
  '/travel/disney/disney-deals/',
  '/travel/disney/get-started/',
  '/travel/disney/planning/',
  '/travel/disney/quote/',
  '/travel/disney/quote/thanks/',
  '/travel/disney/when-to-go/',
  '/travel/disney/where-to-stay/',
  '/travel/disney/why-aaa/',
  '/travel/international/',
  '/travel/magazine/',
  '/travel/quote/',
  '/travel/sightseeing/',
  '/travel/store/',
  '/travel/trains/',
  '/travel/travel-preparation/',
  '/travel/triptiks/',
  '/travel/alerts/',
  '/travel/business/',
  '/traffic-safety/advocacy/',
  '/traffic-safety/distracted-driving/',
  '/traffic-safety/driving-classes/',
  '/traffic-safety/driving-schools-nc/',
  '/traffic-safety/driving-schools-sc/',
  '/traffic-safety/kids/',
  '/traffic-safety/newsletter/',
  '/traffic-safety/seniors/',
  '/traffic-safety/teens/',
  '/traffic-safety/videos-studies/',
  '/uic/claims/',
  '/uic/customer-service/',
  '/uic/motorcycle/',
  '/uic/partner-with-us/',
  '/uic/why-uic/',
];
